import data from "../../../../platform_common_constants/widgets.json"

export const WidgetUId = data;

export const chartColors = [
  '#194D74', '#0969DA', '#8E4EC6', '#BDEE63', '#13A389',
  '#F76B15', '#E03997', '#F2C94C', '#E42F2F', '#5E4DB2',
  '#00679B', '#B5260B', '#136F45', '#E5A500', '#5700D1',
  '#12837C', '#9F269F', '#8D0448', '#0094D5', '#C5B200'
];